import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button } from '../../components/Form/Button';
import { TextInput } from '../../components/Form/TextInput';
import { Icon, pencil_simple_filled } from '../../components/Icon/Icon';
import { WITH_CREDENTIALS } from '../../components/utils';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { ApiList } from '../../types';
import { Column } from '../Column/Column';
import { InputAlertMessage } from '../Form/InputAlertMessage';
import { Row } from '../Row/Row';
import './TitleEditInput.css';

export const TitleEditInput = ({ list, loading: waiting }: { list: ApiList; loading: boolean }): JSX.Element => {
	const { api } = useConfig();
	const [inEdit, setInEdit] = useState(false);
	const [name, setName] = useState(list.name);
	const [hover, setHover] = useState(false);
	const [valid, setValid] = useState<boolean | null>(null);
	const [loading, setLoading] = useState(false);
	const t = {
		...useTranslation().generic,
		form: useTranslation().form,
		subscriptions: useTranslation().subscriptions,
	};

	const validate = () => {
		setValid(name !== '');
	};

	const saveListName = async (): Promise<void> => {
		setLoading(true);

		const payload = {
			op: 'replace',
			path: '/name',
			value: name,
		};

		await axios.patch(`${api}me/lists/${list.id}.json`, [payload], WITH_CREDENTIALS);

		setLoading(false);
	};

	useEffect(() => {
		setName(list.name);
		setValid(null);
	}, []);

	return (
		<div className="title-edit-input">
			{inEdit ? (
				<Column>
					<Row>
						<TextInput
							autoFocus
							onBlur={() => {
								validate();
							}}
							value={name}
							onChange={(e) => {
								setName(e.target.value);
							}}
							placeholder=""
						/>

						<Button
							disabled={loading || name === ''}
							onClick={async () => {
								await saveListName();
								setHover(false);
								setInEdit((draft) => !draft);
							}}
						>
							{loading ? t.saving : t.save}
						</Button>
						<Button
							className="secondary"
							onClick={() => {
								setInEdit((draft) => !draft);
								setHover(false);
								setName(list.name);
								setValid(null);
							}}
						>
							{t.cancel}
						</Button>
					</Row>
					{valid === false && (
						<InputAlertMessage type={'error'} message={`${t.form.name} ${t.subscriptions.missing}`} />
					)}
				</Column>
			) : (
				<h2
					style={{ pointerEvents: waiting ? 'none' : 'inherit' }}
					onMouseEnter={() => {
						setHover(true);
					}}
					onMouseLeave={() => {
						setHover(false);
					}}
					onClick={() => {
						setInEdit((draft) => !draft);
					}}
				>
					{name}
					{!waiting && hover && <Icon shape={pencil_simple_filled} />}
				</h2>
			)}
		</div>
	);
};
